// extracted by mini-css-extract-plugin
export default {"tab":"fileTabButton_tab__0-ZFV","active":"fileTabButton_active__+rZM5","indicator-new":"fileTabButton_indicator-new__KmwZu"};